<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col lg="6"> List Jurnal Mengajar </v-col>
        <v-col lg="6" align="right">
          <v-btn dark color="blue" @click="$router.push('/jurnal/entri')">
            <v-icon>mdi-plus</v-icon>
            Tambah
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-text-field
          label="Search"
          v-model="filter.search"
          @change="
            () => {
              options.page = filter.page = 1;
              get();
            }
          "
          append-icon="mdi-magnify"
        ></v-text-field>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="[
          {
            text: 'Hari, Tanggal',
            value: 'tanggal',
          },
          {
            text: 'Guru',
            value: 'guru.nama',
          },
          {
            text: 'Mata Pelajaran',
            value: 'mata_pelajaran.nama',
          },
          {
            text: 'Pokok Bahasan',
            value: 'pokok_bahasan',
          },
          {
            text: 'Rombel / Ruang / Jam Ke',
            value: 'jadwal',
          },
          {
            text: 'Dokumentasi',
            value: 'dokumentasi',
          },
          {
            text: 'Presensi',
            value: 'presensi',
          },
          {
            text: 'Opsi',
            value: 'actions',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.jadwal" slot-scope="{ item }">
          <span>
            {{ item.rombel ? item.rombel.rombel : "-" }}
            /
            {{ item.ruang || "-" }}
            /
            {{ item.jam_kbm_full }}
          </span>
        </template>

        <template slot="item.dokumentasi" slot-scope="{ item }">
          <v-btn
            v-if="item.dokumentasi"
            small
            text
            color="blue"
            role="a"
            :href="item.dokumentasi_url"
            target="_blank"
            >Lihat</v-btn
          >
        </template>

        <template slot="item.tanggal" slot-scope="{ item }">
          {{ item.hari.toUpperCase() }},
          {{ item.tanggal }}
        </template>

        <template slot="item.presensi" slot-scope="{ item }">
          <v-btn
            color="primary"
            small
            text
            @click="$router.push('/jurnal/list/' + item.id)"
          >
            <v-icon>mdi-eye</v-icon>
            <v-icon>mdi-pen</v-icon>
          </v-btn>
        </template>

        <template slot="item.actions" slot-scope="{ item }">
          <div>
            <v-btn
              icon
              color="red"
              @click="
                req = item;
                modal.delete = true;
              "
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="modal.delete">
      <v-card width="450">
        <v-form @submit.prevent="destroy">
          <v-card-title>Hapus List Jurnal Mengajar</v-card-title>
          <v-card-text>Anda yakin menghapus data terpilih?</v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Hapus</v-btn>
            <v-btn type="button" text color="red" @click="modal.delete = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal.anulir">
      <v-card width="450">
        <v-form @submit.prevent="anulir">
          <v-card-title>Anulir List Jurnal Mengajar</v-card-title>
          <v-card-text>Anda yakin menganulir data terpilih?</v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Konfirmasi</v-btn>
            <v-btn type="button" text color="red" @click="modal.anulir = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        delete: false,
        anulir: false,
      },
      req: {},
      is: {
        loading: true,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
    };
  },
  created() {
    this.get();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    get() {
      this.req = {};
      this.is.loading = true;
      this.filter.status = "1";
      if (this.$root.app.xlevel !== "admin") {
        this.filter.guru_id = this.$root.app.xid;
      }
      this.$root.app.http
        .get("/api/matapelajaran/jurnalmengajar", this.filter)
        .then((res) => {
          this.datas = res.data;
          this.recordsTotal = res.recordsTotal;
          this.is.loading = false;
        });
    },
    destroy() {
      this.$root.app.http
        .del("/api/matapelajaran/jurnalmengajar/" + this.req.id)
        .then((res) => {
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.delete = false;
            this.$root.app.notif(res.message);
          }
        });
    },
    anulir() {
      this.req.status = "0";
      this.$root.app.http
        .put("/api/matapelajaran/jurnalmengajar/" + this.req.id, this.req)
        .then((res) => {
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.anulir = false;
            this.$root.app.notif("data berhasil dianulir");
            this.$router.push("/jurnal/anulir");
          }
        });
    },
  },
};
</script>
